import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AudioRecorderService {
  private mediaRecorder: Record<string, MediaRecorder> = {};
  private chunks: Record<string, Blob[]> = {};

  async startRecording(qKey: string): Promise<void> {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    this.mediaRecorder[qKey] = new MediaRecorder(stream);
    this.chunks[qKey] = [];
    this.mediaRecorder[qKey].ondataavailable = (e) => this.chunks[qKey].push(e.data);
    this.mediaRecorder[qKey].start();
  }

  stopRecording(qKey: string): Promise<Blob> {
    return new Promise((resolve) => {
      this.mediaRecorder[qKey].onstop = () => {
        const blob = new Blob(this.chunks[qKey], { type: 'audio/webm' });
        resolve(blob);
      };
      this.mediaRecorder[qKey].stop();
    });
  }
}
